<ion-app>
    <ion-split-pane contentId="main">
      <ion-menu side="start" contentId="main" type="push">
        <ion-content>
            
            <div class="FondoNaranja" >
                <img src="assets/imgs/header_icon.png" height="50" />
                
                <ion-label class="ion-text-wrap">
                    <h2 class="OrangeBG" *ngIf="userData!=null">
                        <br>{{userData.nombre}}
                        <br>{{userData.email}}
                    </h2>
                    
                </ion-label>
            </div>
                
            <ion-list lines="none" class="ion-margin-top">
                
                <ion-menu-toggle auto-hide="false">
                    <ion-item button routerDirection="root" detail="false" (click)="openHome()" >
                        <ion-icon slot="start" color="consulta" name="home"></ion-icon>
                        <ion-label>Inicio</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                
                
                <ion-menu-toggle auto-hide="false">
                    <ion-item button routerDirection="root" detail="false" (click)="openPage('favoritos')">
                        <ion-icon slot="start" color="consulta" name="medkit"></ion-icon>
                        <ion-label>Mi botiquín</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle auto-hide="false">
                    <ion-item button routerDirection="root" detail="false" (click)="openPage('casos')">
                        <ion-icon slot="start" color="consulta" name="pulse"></ion-icon>
                        <ion-label>Mis últimos casos</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle auto-hide="false">
                    <ion-item button lines="none" routerDirection="root" detail="false" (click)="openPage('cambiar-password')">
                        <ion-icon slot="start" color="consulta" name="lock-closed"></ion-icon>
                        <ion-label>Mi contraseña</ion-label>
                    </ion-item>                    
                </ion-menu-toggle>
                
                <ion-menu-toggle auto-hide="false">
                    <ion-item button routerDirection="root" detail="false" (click)="openPage('sugerencias')">
                        <ion-icon slot="start" color="consulta" name="megaphone"></ion-icon>
                        <ion-label>Errores y sugerencias&nbsp;&nbsp;<ion-badge mode="ios" color="icongrey">{{sugerenciasBadge}}</ion-badge></ion-label>
                    </ion-item>
                </ion-menu-toggle>
                
                <ion-menu-toggle auto-hide="false">
                    <ion-item button routerDirection="root" detail="false" (click)="openPage('abreviaturas')">
                        <ion-icon slot="start" color="consulta" name="custom-abreviaturas"></ion-icon>
                        <ion-label>Abreviaturas</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle auto-hide="false">
                    <ion-item button lines="none" routerDirection="root" detail="false" (click)="openPage('simbolos')">
                        <ion-icon slot="start" color="consulta" name="toggle"></ion-icon>
                        <ion-label>Símbolos</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                
                <ion-menu-toggle auto-hide="false">
                    <ion-item button routerDirection="root" detail="false" (click)="openPage('cientificos')">
                        <ion-icon slot="start" color="consulta" name="school" ></ion-icon>
                        <ion-label>Autores</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                                
                <ion-menu-toggle auto-hide="false">
                    <ion-item button lines="none" routerDirection="root" detail="false" (click)="openPage('tutoriales')">
                        <ion-icon slot="start" color="consulta"    name="videocam"></ion-icon>
                        <ion-label>Tutoriales</ion-label>
                    </ion-item>
                </ion-menu-toggle>

                <ion-menu-toggle auto-hide="false">
                    <ion-item button routerDirection="root" detail="false" (click)="closeSession()">
                        <ion-icon slot="start" color="consulta" name="exit"></ion-icon>
                        <ion-label>Cerrar sesión</ion-label>
                    </ion-item>
                </ion-menu-toggle>
            </ion-list>
            
            <ion-list lines="none">
                <ion-item>
                    <ion-button fill="clear" color="secondary" (click)="abreAvisoLegal()">Aviso legal</ion-button>
                </ion-item>
                <ion-item>
                    <ion-button fill="clear" color="secondary" (click)="abreCondicionesUso()">Condiciones de uso</ion-button>
                    <ion-button slot="end" fill="clear" >v.{{formatVersion(versionInstalada)}}</ion-button>
                </ion-item>
            </ion-list>
            
            
        </ion-content>
      </ion-menu>
      <ion-router-outlet id="main" main></ion-router-outlet>
    </ion-split-pane>
  </ion-app>